

















import { createComponent } from "@vue/composition-api";
import { komponentResource } from "@megarax/client/src/resources/plm/Komponent";
import ResourceItemTable from "@/components/resource/ResourceItemTable.vue";

export default createComponent({
  components: { ResourceItemTable },
  setup(props, ctx) {
    return {
      resource: komponentResource,
    };
  },
});
